import { render, staticRenderFns } from "./LockersServiceProviders.vue?vue&type=template&id=ace90f44&"
import script from "./LockersServiceProviders.vue?vue&type=script&lang=ts&"
export * from "./LockersServiceProviders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports